import { Fragment } from "react";
import useSharedData from "../../hooks/useSharedData";
import Footer from "../../modules/public/footer/footer";
import Menu from "../../modules/public/menu/menu";
import PreOrderCodeCreate from "./PreOrderCodeCreate";
import PreOrderCodeList from "./PreOrderCodeList";

export default function PreOrderCodePage() {
  const { isAgent, canUsePreOrderCode } = useSharedData();

  return (
    <Fragment>
      <Menu />
      <main className="flex-grow-1 rtl-all container py-5">
        {isAgent && canUsePreOrderCode && (
          <Fragment>
            <h4>لیست کد پیش سفارش</h4>
            <PreOrderCodeCreate />
            <PreOrderCodeList />
          </Fragment>
        )}
      </main>
      <Footer />
    </Fragment>
  );
}
